import React from 'react'
import { map } from 'lodash'
import { Row } from 'react-table'

import format from 'civic-champs-shared/utils/format'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { CheckIn } from '../types'
import { ExportButton } from 'core/table/components'

export interface ExportCheckInsButtonProps {
  data: Row<CheckIn>[]
  disabled?: boolean
}

const formatPhones = (phones: string[], obj: any) =>
  phones.reduce((acc: any, phone: string) => ({ ...acc, [phone]: format.phoneNumber(obj?.[phone]) }), {})

const headers = [
  { label: 'Volunteer ID', key: 'id' },
  { label: 'Volunteer First Name', key: 'firstName' },
  { label: 'Volunteer Last Name', key: 'lastName' },
  { label: 'Volunteer Email Address', key: 'email' },
  { label: 'Volunteer Mobile Phone', key: 'phoneNumber' },
  { label: 'Volunteer Home Phone', key: 'homePhoneNumber' },
  { label: 'Volunteer Address', key: 'address' },
  { label: 'Volunteer Groups', key: 'groups' },
  { label: 'Volunteer Tags', key: 'tags' },
  { label: 'Emergency Contact First Name', key: 'emergencyContact.givenName' },
  { label: 'Emergency Contact Last Name', key: 'emergencyContact.familyName' },
  { label: 'Emergency Contact Relationship', key: 'emergencyContactRelationship' },
  { label: 'Emergency Contact Mobile Phone', key: 'emergencyContact.phoneNumber' },
  { label: 'Emergency Contact Work Phone', key: 'emergencyContact.workPhoneNumber' },
  { label: 'Emergency Contact Home Phone', key: 'emergencyContact.homePhoneNumber' },
  { label: 'Emergency Contact Email Address', key: 'emergencyContact.email' },
  { label: 'Opportunity Name', key: 'opportunityName' },
  { label: 'Check-In Time', key: 'checkInTime' },
]

const formatData = (checkIns: Row<CheckIn>[]) =>
  checkIns.map(({ original: { user, opportunity, checkedInAt } }) => ({
    id: user.id,
    firstName: user.givenName,
    lastName: user.familyName,
    email: user.email,
    phoneNumber: format.phoneNumber(user.phoneNumber),
    homePhoneNumber: format.phoneNumber(user.homePhoneNumber),
    groups: user.groups,
    tags: map(user.tags, (tag: any) => tag.name).join(', '),
    address: format.address(user.address),
    emergencyContactRelationship: user.emergencyContactRelationship,
    emergencyContact: {
      ...user.emergencyContact,
      ...formatPhones(['phoneNumber', 'homePhoneNumber', 'workPhoneNumber'], user.emergencyContact),
    },
    opportunityName: opportunity.name,
    checkInTime: format.datetime(checkedInAt),
  }))

export const ExportCheckInsButton = ({ data, disabled }: ExportCheckInsButtonProps) => {
  const organization = useCurrentOrg()

  return (
    <ExportButton
      data={data}
      disabled={disabled}
      formatData={formatData}
      headers={headers}
      filename={`${organization.name}_check-ins.csv`}
    />
  )
}
